export type SurfaceTone = 'workspace' | 'admin' | 'vendor';

export type SurfaceTonePalette = {
  borderClass: string;
  bgClass: string;
  bgHoverClass: string;
  textClass: string;
  textMutedClass: string;
  shortcutClass: string;
  iconClass: string;
  iconHoverClass: string;
  groupHoverTextClass: string;
  copyButtonIdleClass: string;
  copyButtonHoverClass: string;
};

export const surfaceTonePalette: Record<SurfaceTone, SurfaceTonePalette> = {
  workspace: {
    borderClass: 'border-purple-300/40',
    bgClass: 'bg-purple-400/10',
    bgHoverClass: 'hover:bg-purple-400/16',
    textClass: 'text-purple-100',
    textMutedClass: 'text-purple-100/80',
    shortcutClass: 'text-purple-200/70',
    iconClass: 'text-purple-100',
    iconHoverClass: 'hover:text-white',
    groupHoverTextClass: 'group-hover:text-purple-50',
    copyButtonIdleClass: 'text-purple-100/75',
    copyButtonHoverClass: 'hover:border-purple-300/40 hover:bg-purple-400/10 hover:text-purple-100',
  },
  admin: {
    borderClass: 'border-rose-300/40',
    bgClass: 'bg-rose-400/10',
    bgHoverClass: 'hover:bg-rose-400/16',
    textClass: 'text-rose-100',
    textMutedClass: 'text-rose-100/80',
    shortcutClass: 'text-rose-200/70',
    iconClass: 'text-rose-100',
    iconHoverClass: 'hover:text-white',
    groupHoverTextClass: 'group-hover:text-rose-50',
    copyButtonIdleClass: 'text-rose-100/75',
    copyButtonHoverClass: 'hover:border-rose-300/40 hover:bg-rose-400/10 hover:text-rose-100',
  },
  vendor: {
    borderClass: 'border-emerald-300/40',
    bgClass: 'bg-emerald-400/10',
    bgHoverClass: 'hover:bg-emerald-400/16',
    textClass: 'text-emerald-100',
    textMutedClass: 'text-emerald-100/80',
    shortcutClass: 'text-emerald-200/70',
    iconClass: 'text-emerald-100',
    iconHoverClass: 'hover:text-white',
    groupHoverTextClass: 'group-hover:text-emerald-50',
    copyButtonIdleClass: 'text-emerald-100/75',
    copyButtonHoverClass: 'hover:border-emerald-300/40 hover:bg-emerald-400/10 hover:text-emerald-100',
  },
};

/**
 * ENT-6060: the admin accent as a two-state switch. `on` is the solid fill the sidebar's Admin
 * Profile link takes on hover (`SurfaceSidebarPortalLink` accent `rose`); `off` is the same red as
 * an outline, so on and off differ by fill rather than by a decorative ring.
 */
export const ADMIN_ACCENT_SWITCH_CLASSES = {
  on: 'border-red-900 bg-red-900 text-white hover:bg-red-900 hover:text-white dark:border-rose-300/70',
  off: 'border-red-900 bg-background text-red-900 hover:bg-rose-50 hover:text-red-900 dark:border-rose-300/70 dark:text-rose-200 dark:hover:bg-red-950 dark:hover:text-rose-100',
} as const;
